import { Stack } from '@mui/material'
import I18n from 'i18n-js'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import Billboards from '@src/components/content/Billboards'
import CampaignContentDiscovery from '@src/components/content/CampaignContentDiscovery'
import campaignContentPaths from '@src/components/content/campaignContentPaths'
import OrganicCampaignsContent from '@src/components/content/OrganicCampaignsContent'
import PaidAdCampaigns from '@src/components/content/PaidAdCampaigns/PaidAdCampaigns'
import FilterContentLayoutWrapper from '@src/components/shared/FilterContentLayoutWrapper'

import { selectors } from '../../stores'
import FPPAPModalRoute from '../FPPAPModalRoute'
import IGAutomationDialog from '../shared/IGAutomation/IGAutomationDialog'

import UnclaimedAdsChip from './UnclaimedAdsChip'

const CampaignContentPage: React.FC<React.PropsWithChildren> = () => {
  const ref = useRef<HTMLDivElement>(null)
  const [currentRef, setCurrentRef] = useState<HTMLDivElement | null>(null)
  const { expiringAd } = useSelector(
    selectors.paidAds.selectAdWithStartDateLessThanTwoDays,
  )
  const { id, brandName } = expiringAd || {}

  const [isIGAutomationDialogOpen, setIsIGAutomationDialogOpen] =
    useState(false)

  useEffect(() => {
    if (ref && ref.current) {
      setCurrentRef(ref.current)
    }
    return () => {
      setCurrentRef(null)
    }
  }, [ref])

  const params = campaignContentPaths.index.useParams()

  const { retailerAccountSlug, activeTab = 'organic' } = params

  const props = {
    title: I18n.t('nav.brandContent'),
    slotProps: {
      tab: {
        paths: campaignContentPaths,
        selectedTab: activeTab,
        tabs: [
          {
            label: (
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <span>{I18n.t('content.paidAdCampaignsHeader')}</span>
                <UnclaimedAdsChip brandFilter="brand" />
              </Stack>
            ),
            value: 'paid',
          },
          { label: I18n.t('content.organicCampaignsHeader'), value: 'organic' },
          {
            label: I18n.t('content.recommendedContent'),
            value: 'content-discovery',
          },
        ],
      },
      messageBar:
        id && brandName
          ? {
              isDismissable: true,
              link: campaignContentPaths.activatePaidCampaign.build({
                retailerAccountSlug,
                activeTab,
                campaignId: id,
              }),
              linkText: I18n.t('content.viewCampaign'),
              text: I18n.t('content.expiringCredits', { brandName }),
              type: 'warning',
            }
          : undefined,
    },
  }
  return (
    <FilterContentLayoutWrapper {...props} slot={{ filter: <div ref={ref} /> }}>
      <Billboards setIsIGAutomationDialogOpen={setIsIGAutomationDialogOpen} />
      {currentRef && activeTab === 'paid' && (
        <PaidAdCampaigns brandFilter="brand" filterBarRef={ref.current} />
      )}
      {currentRef && activeTab === 'organic' && (
        <OrganicCampaignsContent
          brandFilter="brand"
          filterBarRef={ref.current}
        />
      )}
      {currentRef && activeTab === 'content-discovery' && (
        <CampaignContentDiscovery
          brandFilter="brand"
          filterBarRef={ref.current}
        />
      )}

      <FPPAPModalRoute path={campaignContentPaths.activatePaidCampaign.path} />

      {isIGAutomationDialogOpen && (
        <IGAutomationDialog
          open={isIGAutomationDialogOpen}
          onClose={() => {
            setIsIGAutomationDialogOpen(false)
          }}
        />
      )}
    </FilterContentLayoutWrapper>
  )
}
export default CampaignContentPage
